var asg = "/asg/Api/V1/";
var asgAuth = "/auth/Api/V1/";
var crecer = "/crecer/Api/V1/";
var apap = "/apap-vida-termino/API/V1/";
var asgDelete = "/asg/Api/V1/delete/";
var reports = "/reports/Api/V1/";
var workFlow = "/bpm/Api/V1/";
var apapPremium = "/apap-int/api/premium/";
var appointment = "/sales-calendar/Api/v1/";
var notifications = "/notifications/Api/v1/";
export var URLs = {
    login: asgAuth + "Users/LogIn",
    byPassLogin: asgAuth + "Users/Decode",
    msLogin: asgAuth + "sso/microsoft/validate",
    collection: asg + "Collections/Generate",
    collections: asg + "Collections",
    collectionsUpload: asg + "Collections/Inputs",
    user: asgAuth + "Users",
    spaces: asg + "Spaces",
    contacts: asg + "Contacts",
    insuranceType: asg + "ProjectType",
    insurance: asg + "Project",
    identificationType: asg + "IdentificationType",
    coverType: asg + "CoverType",
    coverTypePlan: asg + "CoverTypePlan",
    premiumEvalOption: asg + "PremiumEvalOption",
    countries: asg + "Countries",
    region: asg + "Region",
    project: asg + "Project",
    sponsor: asg + "Sponsor",
    client: asg + "Client",
    person: asg + "Person",
    plan: asg + "Catalog",
    catalog: asg + "Catalog",
    deleteEntity: asg + "delete",
    plans: asg + "Plan",
    campaign: asg + "Campaign",
    campaignProject: asg + "CampaignProject",
    quote: asg + "Quote",
    insured: asg + "Insured",
    policy: asg + "Policy",
    cancelPolicy: asg + "CancellationPolicy",
    avatar: asg + "Avatars",
    planBenefit: asg + "Benefit",
    beneficiary: asg + "Beneficiary",
    pageActionFlags: asg + "PageActionFlags",
    accountType: asg + "AccountTypes",
    branches: asg + "Branches",
    paymentMode: asg + "PaymentModes",
    projectType: asg + "ProjectType",
    properties: asg + "Properties",
    propertiesClient: asg + "PropertiesClient",
    cancelQuote: asg + "CancelQuote",
    currencies: asg + "Currencies",
    rol: asgAuth + "Roles",
    permission: asgAuth + "Permissions",
    certificate: asg + "Certificates",
    certTemplates: asg + "CertTemplates",
    schemas: asg + "Schemas",
    certificateDocumentEntity: asgDelete + "CertificateDocumentEntity",
    //APAP_AUTO
    vehicle: "".concat(crecer, "Vehicles"),
    carColor: "".concat(crecer, "Vehicles/Colors"),
    // workFlow: `${workFlow}`,
    //APAP_VIDA_TERMINO
    calculations: "".concat(apap, "Calculations"),
    //user
    getUser: asgAuth + "Users",
    createUser: asgAuth + "Users",
    updateUser: asgAuth + "Users",
    updateUserRol: asgAuth + "Users/Roles",
    //REPORTS
    reports: "".concat(reports, "Reports"),
    executeReport: "".concat(reports, "Reports/ExecuteReport"),
    //APAP PREMIUM
    apapPremium: "".concat(apapPremium, "calculate"),
    //WORKFLOWS
    workFlow: "".concat(workFlow, "Workflows"),
    //NOTIFICATIONS
    notificationsSend: "/notifications/Api/V1/notifications",
    emailSendLog: "".concat(notifications, "notifications/email-send-log"),
    emailSendLogExport: "".concat(notifications, "notifications/email-send-log/export"),
    //Appointments
    appointmentByQuote: "".concat(appointment, "appointments/by-quote"),
    changeLogByAppointment: "".concat(appointment, "appointments/changelog"),
    appointments: "".concat(appointment, "appointments"),
    //Audits
    auditsLogs: asg + "Audits/Logs",
};
export var Methods = {
    post: "post",
    get: "get",
    put: "put",
    delete: "delete",
    patch: "patch",
};
